import { render, staticRenderFns } from "./AishortPackageTable.vue?vue&type=template&id=22259736&scoped=true"
import script from "./AishortPackageTable.vue?vue&type=script&lang=js"
export * from "./AishortPackageTable.vue?vue&type=script&lang=js"
import style0 from "./AishortPackageTable.vue?vue&type=style&index=0&id=22259736&prod&lang=scss&scoped=true"
import style1 from "./AishortPackageTable.vue?vue&type=style&index=1&id=22259736&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22259736",
  null
  
)

export default component.exports